import { frontendURL } from '../../../../helper/URLHelper';
import SettingsWrapper from '../SettingsWrapper.vue';
import Flows from './Index.vue';
import FlowBuilderPage from './builder/FlowBuilderPage.vue';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/flows/:flowId/builder'),
      name: 'flows_builder',
      component: FlowBuilderPage,
      meta: {
        permissions: ['administrator'],
      },
    },
    {
      path: frontendURL('accounts/:accountId/settings/flows'),
      component: SettingsWrapper,
      children: [
        {
          path: '',
          redirect: to => {
            return { name: 'flows_list', params: to.params };
          },
        },
        {
          path: 'list',
          name: 'flows_list',
          component: Flows,
          meta: {
            permissions: ['administrator'],
          },
        },
      ],
    },
  ],
};
